import { useContentResource } from "@ctv/core";
import { Text, Token, View } from "@ctv/shared-core/src";

import AirportTransportIcon from "@traveloka/icon-kit-web/react/IcProductAirportTransportFill";
import CarRentalIcon from "@traveloka/icon-kit-web/react/IcProductCarRentalFill";
import FlightIcon from "@traveloka/icon-kit-web/react/IcProductFlightFill";
import HotelIcon from "@traveloka/icon-kit-web/react/IcProductHotelFill";
import InsuranceIcon from "@traveloka/icon-kit-web/react/IcProductInsuranceEbillFill";
import { StyleSheet } from "react-native";

import { ExistingProductTypes } from "../../../_constants";

type Props = {
  type: ExistingProductTypes;
  isSelected: boolean;
};

export default function ProductType({ type, isSelected }: Props) {
  const { CorporateRegistrationProductType: crpt } = useContentResource();
  const { color, icon: Icon } = ICON_VARIANT[type];

  const productToggleStyle = [
    styles.product,
    isSelected && { ...styles.productIsActive, backgroundColor: color },
  ];
  return (
    <View spacing="xs" style={productToggleStyle}>
      <View align="center" justify="center" style={styles.icon}>
        <Icon width={24} height={24} />
      </View>
      <View align="center" justify="center">
        <Text
          variant="ui-small"
          ink={isSelected ? "white-primary" : "black-primary"}
          style={styles.text}
          numberOfLines={2}
        >
          {crpt[type]}
        </Text>
      </View>
    </View>
  );
}

/**
 * Constant
 */
const ICON_VARIANT = {
  FLIGHT: {
    color: Token.color.highAltitude,
    icon: FlightIcon,
  },
  HOTEL: {
    color: Token.color.goodNight,
    icon: HotelIcon,
  },
  CAR_RENTAL: {
    color: Token.color.fuelTank,
    icon: CarRentalIcon,
  },
  AIRPORT_TRANSPORT: {
    color: Token.color.terminalLounge,
    icon: AirportTransportIcon,
  },
  INSURANCE: {
    color: Token.color.businessSuit,
    icon: InsuranceIcon,
  },
};

/**
 * Styles
 */
const animationStyle = {
  transitionDuration: `${Token.timing.instant}ms`,
  transitionTimingFunction: "ease-in",
};

const styles = StyleSheet.create({
  icon: {
    backgroundColor: Token.color.lightStain,
    borderRadius: Token.borderRadius.rounded,
    height: 40,
    width: 40,
  },
  text: {
    ...animationStyle,
    textAlign: "center",
    fontWeight: "500",
    transitionProperty: "color",
  },
  product: {
    ...animationStyle,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: Token.color.lightPrimary,
    borderColor: Token.color.lightSecondary,
    borderRadius: Token.borderRadius.normal,
    borderWidth: Token.borderWidth.thick,
    transitionProperty: "background-color",
    width: 96,
    height: 92,
  },
  productIsActive: {
    borderWidth: 0,
    paddingVertical: Token.spacing.s,
  },
});
